import API from "./base.service";

export const fetchPlans = async (payload = {}) => {
  try {
    const res = await API.get("/plans", { params: payload });
    return res?.data?.body || [];
  } catch (error) {
    console.error("Error fetching plans:", error);
    throw error;
  }
};
export const fetchMyPlans = async (audience) => {
  try {
    const res = await API.get("/plans/findMyPlans", {
      params: audience ? { audience } : undefined,
    });
    return res?.data?.body || [];
  } catch (error) {
    console.error("Error fetching plans:", error);
    throw error;
  }
};

export const createPlan = async (payload) => {
  try {
    const res = await API.post("/plans/custom", payload);
    return res?.data?.body;
  } catch (error) {
    console.error("Error creating plan:", error);
    throw error;
  }
};

export const updatePlan = async (planId, payload) => {
  try {
    const res = await API.put(`/plans/${planId}`, payload);
    return res?.data?.body;
  } catch (error) {
    console.error("Error updating plan:", error);
    throw error;
  }
};

export const subscribeCompanyToPlan = async ({
  companyId,
  planId,
  subscription_type,
}) => {
  try {
    const res = await API.post(`/payments/subscribe`, {
      plan_id: planId,
      company_id: companyId,
      subscription_type,
    });
    return res?.data;
  } catch (error) {
    console.error("Error subscribing company to plan:", error);
    throw error;
  }
};
export const subscribeCompanyToPlanAdmin = async ({
  companyId,
  planId,
  subscription_type,
}) => {
  try {
    const res = await API.put(`/subscriptions/change-plan`, {
      plan_id: planId,
      company_id: companyId,
      subscription_type,
    });
    return res?.data;
  } catch (error) {
    console.error("Error subscribing company to plan:", error);
    throw error;
  }
};

export const createSubscriptionAdmin = async ({
  companyId,
  planId,
  subscription_type,
}) => {
  try {
    // Direct admin assignment; no payment gateway is involved.
    const res = await API.post(`/subscriptions`, {
      plan_id: planId,
      company_id: companyId,
      subscription_type,
    });
    return res?.data;
  } catch (error) {
    console.error("Error creating admin subscription:", error);
    throw error;
  }
};
export const getSubscription = async (payload = {}) => {
  try {
    return await API.get(`/subscriptions`, {
      params: payload,
    });
  } catch (error) {
    console.error("Error getting subscription:", error);
    throw error;
  }
};
